import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { Links } from '@mobi/oiv-viewer-utils-ng-jslib';
import { MobiUiIconComponent } from '@mobi/rwc-ui-components-ng-jslib';
import { TranslatePipe } from '@mobi/rwc-utils-ng-jslib';

@Component({
    selector: 'oiv-viewer-more-information',
    imports: [MobiUiIconComponent, TranslatePipe],
    templateUrl: './more-information.component.html',
    styleUrl: './more-information.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MoreInformationComponent {
    links = input<Links>();
    items = computed(() => {
        return [
            {
                text: 'oiv.not-found.customer-portal',
                link: this.links()?.notFoundPageCustomerPortal,
                icon: 'application_window',
            },
            {
                text: 'oiv.navigation.title.goToLegalAdviser',
                link: this.links()?.mobiliarLegalAdviser,
                icon: 'application_window',
            },
            {
                text: 'oiv.not-found.contact',
                link: this.links()?.notFoundPageContact,
                icon: 'face',
            },
        ];
    });
}
